var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.load
    ? _c(
        "section",
        { staticClass: "news-section about-footer-bg" },
        [
          _c("header-inner"),
          _c(
            "section",
            { staticClass: "header-bg" },
            [
              _c(
                "wrapper",
                [
                  _c("about-menu", {
                    on: {
                      currentMenu: function($event) {
                        _vm.currentMenu($event)
                      }
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "block desktop" },
                    [
                      _c("h1", {
                        staticClass: "text-blue-2 title-upper font-bold",
                        domProps: { innerHTML: _vm._s(_vm.about.block_title) }
                      }),
                      _c(
                        "nuxt-link",
                        {
                          staticClass: "btn solid--green large",
                          attrs: { to: "/products/outdoor" }
                        },
                        [_vm._v("Узнать о продуктах")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          true
            ? _c(
                "wrapper",
                {
                  staticClass: "page--top page--bottom footer-bg",
                  attrs: { lineBorders: false, lineCenter: true }
                },
                [
                  _c("h1", {
                    staticClass: "text-blue-2 title-upper mobile title-main",
                    domProps: { innerHTML: _vm._s(_vm.about.block_title) }
                  }),
                  _c("section", { staticClass: "typography-text" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.about.text) }
                    }),
                    _c(
                      "div",
                      { staticClass: "buttons text-center" },
                      [
                        _c(
                          "nuxt-link",
                          {
                            staticClass: "btn solid--green large",
                            attrs: { to: "/products/outdoor" }
                          },
                          [_vm._v("Узнать о продуктах")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98fb55d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98fb55d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/company/index.vue
// module id = qj+s
// module chunks = 30